const sceneCount = [6];

module.exports.sceneCount = sceneCount;